import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postTags = (params) => {
    return axios.post(`${backendHost}/api/admin/users/tags`, params);
};